// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `rails generate channel` command.

import { createConsumer } from "@rails/actioncable";
import CookieValue from "../utils/cookie_value";

export default createConsumer(
  process.env.WS_URL + "cable?token=" + CookieValue()
);
